import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { SERVER_PDF_ERROR } from "app-core";
function usePdfActions(source, host) {
  const { t, te } = useI18n();
  const saving = ref(false);
  const emailOpen = ref(false);
  const defaultRecipient = ref("");
  const available = computed(() => source.available());
  const offered = computed(() => source.offered());
  const emailDisabled = computed(() => {
    var _a;
    return !!((_a = host.isTraining) == null ? void 0 : _a.call(host));
  });
  const documentLine = computed(() => source.documentLine());
  function online() {
    if (host.isOnline && !host.isOnline()) {
      host.notify(t("pdf.needs_internet"), "warning");
      return false;
    }
    return true;
  }
  function errorMessage(code) {
    return code && te(`pdf.errors.${code}`) ? t(`pdf.errors.${code}`) : t("pdf.errors.general");
  }
  async function save() {
    if (!offered.value || saving.value || !online()) return;
    saving.value = true;
    host.notify(t("pdf.preparing"), "info");
    try {
      const result = await source.save();
      host.notify(result.success ? t("pdf.saved") : errorMessage(result.error), result.success ? "success" : "error");
    } catch (error) {
      console.error("Server PDF: save failed", error);
      host.notify(errorMessage(), "error");
    } finally {
      saving.value = false;
    }
  }
  async function openEmail() {
    if (!offered.value || emailDisabled.value || !online()) return;
    defaultRecipient.value = await source.defaultRecipient();
    emailOpen.value = true;
  }
  async function send(to) {
    if (!offered.value) return { success: false, error: SERVER_PDF_ERROR.general };
    const result = await source.email(to);
    if (result.success) {
      try {
        await source.afterSent(to);
      } catch (error) {
        console.error("Server PDF: after the send", error);
      }
    }
    return result;
  }
  const actions = computed(() => {
    const hint = source.missingHint();
    const blocked = !offered.value || saving.value;
    return [
      { key: "save", label: t("pdf.save"), icon: "i-lucide-file-down", disabled: blocked, hint, run: () => {
        void save();
      } },
      { key: "email", label: t("pdf.email_action"), icon: "i-lucide-mail", disabled: blocked || emailDisabled.value, hint, run: () => {
        void openEmail();
      } }
    ];
  });
  function onSent(email) {
    host.notify(t("pdf.sent", { email }), "success");
  }
  function onFailed(code) {
    if (code === SERVER_PDF_ERROR.timeout) {
      host.notify(t("pdf.timeout"), "warning");
      return;
    }
    host.notify(errorMessage(code), "error");
  }
  return { available, offered, actions, saving, emailOpen, emailDisabled, defaultRecipient, documentLine, save, openEmail, send, onSent, onFailed };
}
export {
  usePdfActions
};
//# sourceMappingURL=index44.js.map
